import Menu from "../constants/menu.gen"
import Env from "../util/env"
import { HEALTH_AUTH_LIST, GRAPH_AUTH_LIST } from "../constants/conf"

function getAuthedMenus(menus, visibleIds) {
  let res = []
  if (!menus || !menus.length) {
    return res
  }
  menus.forEach((menu) => {
    if (visibleIds.includes(menu.id)) {
      let c = getAuthedMenus(menu.children, visibleIds)
      res.push({
        id: menu.id,
        name: menu.name,
        path: menu.path,
        children: c.length ? c : null,
      })
    }
  })
  return res
}
export default () => {
  let user = Env.getUser()
  let name = user.username || " "
  let visibleIds = [100]
  if(name){
    // visibleIds.push(1)
    //ldap账户有'权限'
    // if(name.includes(".") && user.user_type && user.user_type === 2){
    //   visibleIds.push(26)
    // }
  }
  if(user && user.menus){
    visibleIds.push(...user.menus)
  }
  // if (name) {
  //   visibleIds.push(1)
  //   if (name.includes(".")) {
  //     visibleIds.push(101, 102, 103, 6)
  //   }
  // }
  // if (user.histoAuth) {
  //   visibleIds.push(2, 201, 202)
  // }
  // if (user.positionAuth) {
  //   visibleIds.push(2, 204)
  // }
  // if (user.digitalAuth) {
  //   visibleIds.push(2, 203)
  // }
  // if (user.tagAuth) {
  //   visibleIds.push(4, 401, 3, 301)
  // }
  // if (user.gridAuth) {
  //   visibleIds.push(4, 402)
  // }
  // if (user.singaporeAuth) {
  //   // visibleIds.push(9)
  //   visibleIds.push(25)
  // }
 
  if (GRAPH_AUTH_LIST.includes(name.toLowerCase())) {
    // visibleIds.push(4, 403, 404)
    visibleIds.push(18,21,24)
  }
  if (HEALTH_AUTH_LIST.includes(name)) {
    visibleIds = [800, 100]
  }

  return getAuthedMenus(Menu, visibleIds)
}
